export const compareCalls = (firstValue: boolean | null, secondValue: boolean | null) => {
  const rank = (value: boolean | null) => {
    if (value === false) return 0;
    if (value === true) return 1;
    return 2;
  };

  return rank(firstValue) - rank(secondValue);
};
